// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { Stack, useMediaQuery } from "@mui/material";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 PRO React examples
import DefaultNavbar from "custom/Navbars/DefaultNavbar";
import DefaultFooter from "custom/Footers/DefaultFooter";

// OurBrand page sections
import Values from "pages/about-us/company/OurBrand/sections/Values";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Assets
import background_xl from "assets/images/brand_xl.png";
import background_md from "assets/images/brand_md.png";
import background_sm from "assets/images/brand_sm.png";

function OurBrandPage() {
  const isXs = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const isSm = useMediaQuery((theme) => theme.breakpoints.between("sm", "md"));
  const isMd = useMediaQuery((theme) => theme.breakpoints.between("md", "lg"));
  const isLg = useMediaQuery((theme) => theme.breakpoints.between("lg", "xl"));
  const isXl = useMediaQuery((theme) => theme.breakpoints.up("xl"));

  const determineBackground = () => {
    if (isSm) {
      return background_sm;
    } else if (isMd) {
      return background_sm;
    } else if (isLg) {
      return background_md;
    } else if (isXl) {
      return background_xl;
    } else {
      return background_sm;
    }
  };

  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "/support/contact-us",
          label: "Contáctanos",
          color: "info",
        }}
        mobile={{
          color: "white",
        }}
        transparent
        light
      />
      <MKBox bgColor="white">
        <MKBox
          display="flex"
          alignItems="center"
          minHeight="100vh"
          sx={{
            backgroundImage: ({ palette: { gradients }, functions: { linearGradient, rgba } }) =>
              `${linearGradient(rgba(gradients.dark.main, 0.5), rgba(gradients.dark.state, 0.5))}, url(${determineBackground()})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Container>
            <Grid container item xs={12} sm={12} md={10} lg={9} xl={6} flexDirection="column" justifyContent="center">
              <MKTypography
                variant="h1"
                color="white"
                mb={3}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                Nuestra Historia
              </MKTypography>
              <MKTypography variant="body1" color="white" opacity={0.8} pr={6} mr={6}>
                Comenzamos con un objetivo preciso: reunir expertos en ciberseguridad para brindar servicios excepcionales sin complicaciones innecesarias. Adoptando el principio KISS - 'Keep It Simple, Stupid' - la simplicidad y la eficiencia dan forma a nuestro enfoque.
              </MKTypography>
              <Stack direction="row" spacing={1} mt={3}>
                <MKButton color="white">Únete a Nosotros</MKButton>
                <MKButton variant="text" color="white">
                  Leer Más
                </MKButton>
              </Stack>
            </Grid>
          </Container>
        </MKBox>
        <Values />
        <MKBox pt={10} pb={6}>
          <Container>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={5} ml="auto" sx={{ textAlign: { xs: "center", lg: "left" } }}>
                <MKTypography variant="h4" fontWeight="bold" mb={0.5}>
                  ¡Conéctate con Nosotros!
                </MKTypography>
                <MKTypography variant="body1" color="text">
                  Más que un negocio, somos una comunidad.
                </MKTypography>
              </Grid>
              <Grid
                item
                xs={12}
                lg={7}
                my={{ xs: 5, lg: "auto" }}
                mr={{ xs: 0, lg: "auto" }}
                sx={{ textAlign: { xs: "center", lg: "right" } }}
              >
                <MKSocialButton
                  component="a"
                  href="https://twitter.com/@PWNCAT_OFFICIAL"
                  target="_blank"
                  color="twitter"
                  sx={{ m: 1 }}
                >
                  <i className="fab fa-twitter" />
                  &nbsp;Tweet
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://github.com/offensive-security-pwncat"
                  target="_blank"
                  color="github"
                  sx={{ m: 1 }}
                >
                  <i className="fab fa-github" />
                  &nbsp;Participa
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://www.linkedin.com/company/96064718"
                  target="_blank"
                  color="linkedin"
                  sx={{ m: 1 }}
                >
                  <i className="fab fa-linkedin" />
                  &nbsp;Descubre
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://www.youtube.com/channel/UCzobc3PZEQSsEMF7IFCKryA"
                  target="_blank"
                  color="youtube"
                  sx={{ m: 1 }}
                >
                  <i className="fab fa-youtube" />
                  &nbsp;Sigue
                </MKSocialButton>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </MKBox>
    </>
  );
}

export default OurBrandPage;